import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import * as S from './Popover.styles.js';
import Icon from '../Icon/Icon.js';

const arrowWidth = '10px';
const arrowHeight = '8px';

const Popover = ({ position, content, showArrow, children }) => {
  const positionTranslate = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    'top-right': 'top-end',
    'top-left': 'top-start',
    'bottom-right': 'bottom-end',
    'bottom-left': 'bottom-start',
  };

  const onCloseButton = () => {
    document.body.click();
  };

  const ChildrenWrapper = () => (
    <OverlayTrigger
      trigger='click'
      placement={positionTranslate[position]}
      rootClose
      overlay={
        <S.BasePopover data-testid='popover' position={position}>
          <S.Wrapper>
            {showArrow && (
              <S.Arrow
                data-testid='popover-arrow'
                position={position}
                width={arrowWidth}
                height={arrowHeight}
              />
            )}
            <S.Content>{content}</S.Content>
            <S.CloseButton>
              <Icon
                name='cancel_outline'
                variant='neutral'
                modifier='strong'
                cursor='pointer'
                width={16}
                height={16}
                onClick={onCloseButton}
              />
            </S.CloseButton>
          </S.Wrapper>
        </S.BasePopover>
      }
    >
      {({ ref, ...triggerHandler }) => (
        <S.ChildrenWrapper {...triggerHandler} ref={ref}>
          {children}
        </S.ChildrenWrapper>
      )}
    </OverlayTrigger>
  );

  return (
    <S.Popover position={position} content={content} showArrow={showArrow}>
      {ChildrenWrapper()}
    </S.Popover>
  );
};

Popover.defaultProps = {
  position: 'top',
  showArrow: true,
};

Popover.propTypes = {
  position: PropTypes.oneOf([
    'top',
    'right',
    'bottom',
    'left',
    'top-right',
    'top-left',
    'bottom-right',
    'bottom-left',
  ]),
  content: PropTypes.string.isRequired,
  showArrow: PropTypes.bool,
};
export default Popover;
